export const ENRICHMENT_STATES = ['missing', 'pending', 'applied'];

export const ENRICHMENT_TABS = {
    PRIMARY_ATTRIBUTES: 'primaryAttributes',
    SECONDARY_ATTRIBUTES: 'secondaryAttributes',
    ON_MODEL_IMAGES: 'onModelImages',
    DESCRIPTION: 'description',
};

export const ENRICHMENT_TAB_ORDER = [
    ENRICHMENT_TABS.PRIMARY_ATTRIBUTES,
    ENRICHMENT_TABS.SECONDARY_ATTRIBUTES,
];

/**
 * The product document fields of each state, per attribute tab.
 */
export const ENRICHMENT_STATE_FIELDS = {
    [ENRICHMENT_TABS.PRIMARY_ATTRIBUTES]: {missing: 'enrichmentMissing', pending: 'enrichmentPending', applied: 'enrichmentApplied'},
    [ENRICHMENT_TABS.SECONDARY_ATTRIBUTES]: {missing: 'enrichmentSecondaryMissing', pending: 'enrichmentSecondaryPending', applied: 'enrichmentSecondaryApplied'},
};

export const isAttributeTab = (tab) => undefined !== ENRICHMENT_STATE_FIELDS[tab];

/**
 * The counters of a tab in the POST /enrichment/counts response: the required attributes
 * at its root, the secondary ones under their tab.
 */
export function tabCountsOf(counts, tab) {
    return (ENRICHMENT_TABS.SECONDARY_ATTRIBUTES === tab ? counts?.[tab] : counts) ?? {};
}

export function withTabCounts(counts, tab, tabCounts) {
    return ENRICHMENT_TABS.SECONDARY_ATTRIBUTES === tab ? {...counts, [tab]: tabCounts} : {...counts, ...tabCounts};
}

export const GENDER_TARGET = 'gender';

export const PAGE_SIZES = [25, 50, 100];

const TARGET_ORDER = ['gender', 'color', 'size'];

/**
 * Gender, color and size first, then the attributes in the order of the catalog
 * (GET /enrichment/values, by position).
 */
export function targetComparator(catalog = {}) {
    const attributeOrder = Object.keys(catalog.attributes ?? {});
    const rank = (target) => {
        if (TARGET_ORDER.includes(target)) {
            return TARGET_ORDER.indexOf(target);
        }
        const position = attributeOrder.indexOf(target);

        return TARGET_ORDER.length + (-1 === position ? attributeOrder.length : position);
    };

    return (a, b) => rank(a) - rank(b) || a.localeCompare(b);
}

export function targetLabelId(target) {
    return ['gender', 'color', 'size'].includes(target) ? `enrichment.target.${target}` : 'enrichment.target.attribute';
}

/**
 * The name of a target: gender, color and size are translated, an attribute takes its
 * label from the catalog.
 */
export function targetLabel(intl, catalog, target) {
    return catalog?.attributes?.[target]?.label ?? intl.formatMessage({id: targetLabelId(target)});
}

export const ENRICHMENT_DEFAULT_FILTERS = [
    {id: 'instock', name: 'instock', '@type': 'Stock'},
];
